import React from 'react';
import { compose, withState } from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import Typography from '@material-ui/core/Typography';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { Checkbox, FormGroup } from '@material-ui/core';
import CancelButton from '../atoms/CancelButton';
import ChangeButton from '../atoms/ChangeButton';
import ChangeShashokuOptionDialogConfirm from './ChangeShashokuOptionDialogConfirm';

const styles = {
  description: {
    marginBottom: 10
  },
  alertText: {
    color: '#FF545C'
  }
};

const enhance = compose(withState('message', 'setMessage', ''));

const Main = enhance(
  ({
    classes,
    openChange,
    updateOpenChange,
    openChangeConfirm,
    updateOpenChangeConfirm,
    cancelAction,
    changeAction,
    gochimeshiFlag,
    setGochimeshiFlag,
    shashokuFlag,
    setShashokuFlag,
    gochiKidFlag,
    setGochiKidFlag,
    disableStatus,
    message,
    setMessage
  }) => {
    const changeActionConfirm = () => {
      updateOpenChangeConfirm(true);
      const arr = [];
      if (gochimeshiFlag === 1) {
        arr.push('「ごちめし（さきめし含む）」');
      }
      if (shashokuFlag === 1) {
        arr.push('「社食ごちめし」');
      }
      if (gochiKidFlag === 1) {
        arr.push('「こどもごちめし」');
      }
      if (arr.length) {
        setMessage(
          `${arr.join(
            'と'
          )}のメニューが表示されるようになりますがよろしいでしょうか？`
        );
      } else {
        setMessage('利用用途を更新しましょうか。');
      }
    };
    const cancelActionConfirm = () => {
      updateOpenChangeConfirm(false);
    };
    return (
      <Dialog
        open={openChange}
        onClose={() => {
          updateOpenChange(false);
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <Typography component="p" className={classes.description}>
            利用用途を設定します。
          </Typography>
          <FormGroup>
            <div>
              <FormControlLabel
                label="ごちめし（さきめし含む）"
                control={
                  <Checkbox
                    checked={gochimeshiFlag === 1}
                    onChange={event =>
                      setGochimeshiFlag(event.target.checked ? 1 : 0)
                    }
                    color="primary"
                    disabled={disableStatus}
                  />
                }
              />
            </div>
            <div>
              <FormControlLabel
                label="社食ごちめし"
                control={
                  <Checkbox
                    checked={shashokuFlag === 1}
                    onChange={event =>
                      setShashokuFlag(event.target.checked ? 1 : 0)
                    }
                    color="primary"
                    disabled={disableStatus}
                  />
                }
              />
            </div>
            <div>
              <FormControlLabel
                label="こどもごちめし"
                control={
                  <Checkbox
                    checked={gochiKidFlag === 1}
                    onChange={event =>
                      setGochiKidFlag(event.target.checked ? 1 : 0)
                    }
                    color="primary"
                    disabled
                  />
                }
              />
            </div>
          </FormGroup>
          <div className={classes.alertText}>
            ※こどもごちめしの設定は、こどもごちめしメニューから可能です。
          </div>
        </DialogContent>
        <DialogActions>
          <CancelButton onClickAction={cancelAction} color="default" />
          <ChangeButton
            onClickAction={changeActionConfirm}
            enabled={!disableStatus}
          />
        </DialogActions>
        <ChangeShashokuOptionDialogConfirm
          message={message}
          openChangeConfirm={openChangeConfirm}
          updateOpenChangeConfirm={updateOpenChangeConfirm}
          cancelAction={cancelActionConfirm}
          changeAction={changeAction}
        />
      </Dialog>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
